import collaborationApps from './shards/collaborationApps.json'
import developerToolkitApps from './shards/developerToolkitApps.json'
import financeApps from './shards/financeApps.json'
import productivityApps from './shards/productivityApps.json'

/** Minimal app metadata for Settings Connections and connection UI. */
export const CONNECTION_APP_SECTIONS = [
  { id: 'collaboration', title: 'Collaboration & Communication', apps: collaborationApps },
  { id: 'developer', title: 'Developer Tools & DevOps', apps: developerToolkitApps },
  { id: 'productivity', title: 'Productivity & Project Management', apps: productivityApps },
  { id: 'finance', title: 'Finance & Payments', apps: financeApps },
]
